<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card class="pa-5">
        <v-text-field
          v-model="user"
          label="Email"
          name= "email"
          required
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          required
          type="password"
          @keyup.enter="login"
        ></v-text-field>
        <v-btn large block color="primary" @click="login">
          Login
        </v-btn>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
export default {
  data () {
    return {
      user: '',
      password: ''
    }
  },
  methods: {
    login () {
      firebase.auth().signInWithEmailAndPassword(this.user, this.password).then(() => {
        this.$router.push('/Edit')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue